import { Form, Row, Space } from "antd";
import { AdvancedForm } from "../form/advanced-form";
import {
  useGetTaskQuery
} from "../../../api/plamo-api";
import FormItem from "../form/form-item";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import PlamoApiWithSaveNotifications from "../util/with-save-notification";
import ConfirmButton from "../util/confirm-button";
import { IconAngleDownSolidFull, IconAngleUpSolidFull, IconCircleRegularFull } from "../../../icon";

const { 
  useCreateTaskWithSaveNotificationMutation,
  useUpdateTaskWithSaveNotificationMutation, 
  useDeleteTaskWithSaveNotificationMutation 
} = PlamoApiWithSaveNotifications;


function TasksDetailsPage() {
  const { id: taskIdStr } = useParams();
  const taskId = taskIdStr !== 'new' ? parseInt(taskIdStr || '0') : null;
  const { data: task } = useGetTaskQuery({ id: taskId }, { skip: !taskId }) as any;
  const [createTask] = useCreateTaskWithSaveNotificationMutation();
  const [updateTask] = useUpdateTaskWithSaveNotificationMutation();
  const [deleteTask] = useDeleteTaskWithSaveNotificationMutation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  
    
  const onFinish = useCallback(async (values: any) => {
    if(!taskId) {
      const { data: newTask }:any = await createTask(values);
      console.log("Created new worktime", newTask);
    } else {
      const newTask = {...task, ...values}
      await updateTask(newTask);
    }

  }, [ taskId, createTask, updateTask, task ]);

  const isLoading = false;

  const onDelete = useCallback(async () => {
    await deleteTask({ id: taskId })
    navigate(-1)
  }, [deleteTask, taskId, navigate])

  return <>
    <AdvancedForm form={form} name="worktime" onFinish={onFinish} isLoading={isLoading} originalValues={task} initialEditing={taskIdStr === 'new'}>
      <Row><h3>Todo</h3></Row>
      <Row gutter={24}>
        <FormItem fieldName="text" label="Beschreibung" type="text" />
        <FormItem fieldName="priority" label="Priorität" type="enum" typeData={{ options: [{ label: <><IconAngleDownSolidFull /> Niedrig</>, value: 1 }, { label: <><IconCircleRegularFull /> Mittel</>, value: 3 }, { label: <><IconAngleUpSolidFull /> Hoch</>, value: 5 }] }} />
        <FormItem fieldName="timestamp" label="Fällig" type="date" />
        <FormItem fieldName="assignedUserId" label="Zugewiesen an" type="user" />
      </Row>
      { taskId && <>
        <Row><h3>Todo löschen</h3></Row>
        <div>
          <Space size="small">
            <ConfirmButton type="default" danger onClick={onDelete} confirmTitle={`Todo löschen?`} confirmContent={'Wollen Sie das Todo wirklich löschen?'}>
              Todo löschen
            </ConfirmButton>
          </Space>
        </div>
      </>}
    </AdvancedForm>
  </>
}

export default TasksDetailsPage;